// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
//= require premium/_namespace
//= require_tree .
// MAGIC_DESPROCKET_START
require('javascripts/premium/_namespace.js')
require('javascripts/premium/templates/premium_icon_JST.wjs.js')
// MAGIC_DESPROCKET_END
